import React from 'react'

import { Box, Text, styled } from '@chilipiper/design-system'
import '../availability-mobile.css'
import { UserAvatar } from '@chilipiper/meetings-components'
import { Logo } from '../logo/Logo'
import './book-with.css'
import { Back } from './Back'
import { PickTitle } from './PickTitle'

const StyledImageContainter = styled(Box)`
  img {
    box-shadow: none;
    border: 4px solid rgb(240, 243, 245);
    box-sizing: content-box;
  }
`

interface Props {
  assigneeId?: string
  assigneeName?: string
  hideAssignee?: boolean
  hideBack?: boolean
  hideLogo?: boolean
  isMeetingApprovalFlow?: boolean
  isQueue: boolean
  isReschedule?: boolean
  onBack?: () => void
  showBack?: boolean
}

export const BookWithAssignee = ({
  isReschedule,
  isMeetingApprovalFlow,
  hideBack,
  hideLogo = false,
  onBack,
  assigneeName,
  assigneeId,
  isQueue,
  hideAssignee,
}: Props) => {
  return (
    <div className='fabe-pick-with-holder'>
      <div className='fabe-left-block'>
        {!hideBack && onBack && <Back onBack={onBack} />}
        {!hideAssignee && (
          <StyledImageContainter>
            <UserAvatar
              data-test-id='BookWithAssignee-avatar'
              id={assigneeId}
              name={assigneeName ?? ''}
              isTwoInitials
              borderRadius={8}
              size={9}
            />
          </StyledImageContainter>
        )}
        <div className='fabe-availability-meet-with'>
          <Text as='h1' marginY={0}>
            <PickTitle
              isQueue={isQueue}
              hideAssignee={hideAssignee}
              isReschedule={isReschedule}
              isMeetingApprovalFlow={isMeetingApprovalFlow}
            />
            <Text
              display='block'
              data-test-id='BookWithHeader-assignee-name'
              data-chili-css='book-members'
              fontSize={[14, 16]}
              fontWeight={600}
            >
              {assigneeName}
            </Text>
          </Text>
        </div>
      </div>
      {!hideLogo && (
        <div className='fabe-right-block'>
          <Logo />
        </div>
      )}
    </div>
  )
}
